import "./LoginParkingPage.scss";
import Tracking from "../uidispatcherapi/Tracking";
import { connectWithDefaultStores } from "../stores/stores";
import PropTypes from "prop-types";
import React from "react";
import { SessionStore } from "../uidispatcherapi/SessionStore";
import { FormattedMessage } from "react-intl";
import FeatureSessionStore from "../uidispatcherapi/FeatureSessionStore";
import { wrapLazily } from "../lazy-loading/lazyWrapper";
const IdamCompatibleLogoutLink = wrapLazily(() => import("cia_ui/IdamCompatibleLogoutLink"), {
	usesBootstrap: true,
	usesMoment: true,
});
type IdamError = {
	code: string;
	responseText?: string;
	statusCode?: number;
	data?: any;
};
type Props = {
	idamError: IdamError;
	idamLogoutUrl: string;
};
type State = {
	referenceCode: string;
};

export class DisconnectedLoginParkingPage extends React.Component<Props, State> {
	displayName: "LoginParkingPage";
	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	constructor(props: Props) {
		super(props);
		this.state = {
			referenceCode: SessionStore.getClientSessionId(),
		};
	}

	componentDidMount() {
		if (SessionStore.pending() || SessionStore.loggedIn()) {
			return;
		}

		const idamError = SessionStore.getIdamError();

		if (idamError) {
			Tracking.trackStructuredEvent(
				"platform",
				"uidispatcher",
				"client.errorpage.display",
				{
					tags: {
						url: window.location.pathname,
						error: idamError.code,
						errorInfo: idamError.responseText,
						component: "LoginParkingPage",
					},
				},
				null,
				50,
				this.state.referenceCode,
			);
		}
	}

	getI18nSuffix(code: string | null | undefined): string | null | undefined {
		switch (code) {
			case "wrong-country-employee":
			case "wrong-country-customer":
			case "invalid-cardholder":
			case "invalid-customer":
			case "employee-not-found":
				return String(code).toUpperCase().replace(new RegExp("-", "g"), "_");

			default:
				return null;
		}
	}

	isMetroXWithFlyout() {
		return FeatureSessionStore.getMembershipFor("CA_USE_METROX_ACCOUNT_FLYOUT") === "B";
	}

	render() {
		const idamErrorObject: Record<string, any> | null | undefined = SessionStore.getIdamError();
		const code = idamErrorObject ? idamErrorObject.code : null;
		const data = idamErrorObject ? idamErrorObject.data : null;
		const upn = data ? data.upn : null;
		const cardholderId = data ? data.cardholderId : null;
		const siteCountry = data ? data.expectedCountry : null;
		const userCountry = data ? data.actualCountry : null;
		const suffix = this.getI18nSuffix(code);
		const i18nKey = "PL_LOGIN_ERROR_DETAIL_" + String(suffix);
		const shouldDisplayHeaderWithFlyout = this.isMetroXWithFlyout();
		const metroXClassName = shouldDisplayHeaderWithFlyout ? " with-metro-x-header" : "";
		const idamErrorElement = idamErrorObject ? (
			<React.Fragment>
				{suffix && (
					<h5 className={"test-" + i18nKey}>
						<FormattedMessage
							id={i18nKey}
							values={{
								user: upn,
								userCountry: userCountry,
								siteCountry: siteCountry,
								cardholderId: cardholderId,
							}}
						/>
					</h5>
				)}
				<h5>
					<span className={"test-error-code-" + String(code)}>
						<FormattedMessage
							id="PL_LOGIN_ERROR_CODE"
							values={{
								code: code,
							}}
						/>
					</span>
				</h5>
			</React.Fragment>
		) : null;
		const contents =
			SessionStore.pending() || SessionStore.loggedIn() ? (
				<div>
					<FormattedMessage id="PL_LOADING" />
				</div>
			) : (
				<div>
					<img src="/ordercapture/uidispatcher/static/app/assets/images/error.png" alt="oops" />
					<h1>
						<FormattedMessage id="PL_LOGIN_ERROR_HEADER" />
					</h1>
					<h5>
						<FormattedMessage id="PL_LOGIN_ERROR_DESCRIPTION" />
					</h5>
					<h5>{new Date().toLocaleString("de-DE", { timeZone: "Europe/Berlin" })}</h5>
					<h5>
						<FormattedMessage id="PL_DESCRIPTION_ERROR_REFERENCE_CODE" />
					</h5>
					<h5>
						<span id="error-code">{this.state.referenceCode}</span>
					</h5>
					{idamErrorElement}
					{this.props.idamLogoutUrl && (
						<React.Fragment>
							<FormattedMessage id="PL_LOGIN_ERROR_SUGGESTION" /> &nbsp;
							<IdamCompatibleLogoutLink
								i18nKey="PL_LOGOUT_PAGE"
								className="btn btn-primary test-idam-logout-link idam-logout-link"
							/>
						</React.Fragment>
					)}
				</div>
			);
		return (
			<div>
				<div className={"login-parking" + metroXClassName}>
					<center>{contents}</center>
				</div>
			</div>
		);
	}
}

const wrapped: any = connectWithDefaultStores(
	{
		stores: {
			SessionStore: (s: any) => ({
				idamError: s.getIdamError(),
				idamLogoutUrl: s.getIdamLogoutUrl(),
			}),
		},
	},
	DisconnectedLoginParkingPage,
);
export default wrapped;
